const removeBookendCommasAndSpaces = (str: string) => {
    let start = 0;
    let end = str.length - 1;

    if (end < 2) {
        return str;
    }

    while (start <= end && isCommaOrSpace(str, start)) {
        start++;
    }

    while (end >= start && isCommaOrSpace(str, end)) {
        end--;
    }

    return str.substring(start, end + 1);
};

const isCommaOrSpace = (str: string, i: number) => {
    var char = str[i];
    return (char === ',' || char === ' ');
}

export default removeBookendCommasAndSpaces;
